import _parseInt from 'lodash/parseInt';
import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  GET_DEVICES_LIST,
  GET_DEVICES_LIST_SUCCESS,
  GET_DEVICES_LIST_ERROR,
  GET_DEVICE,
  GET_DEVICE_SUCCESS,
  GET_DEVICE_ERROR,
  GET_DEVICE_INSTALLATION,
  GET_DEVICE_INSTALLATION_SUCCESS,
  GET_DEVICE_INSTALLATION_ERROR,
  LINK_DEVICE_SIMCARD,
  LINK_DEVICE_SIMCARD_SUCCESS,
  LINK_DEVICE_SIMCARD_ERROR,
  UNLINK_DEVICE_SIMCARD,
  UNLINK_DEVICE_SIMCARD_SUCCESS,
  UNLINK_DEVICE_SIMCARD_ERROR,
  SEND_CMD_DEVICE,
  SEND_CMD_DEVICE_SUCCESS,
  SEND_CMD_DEVICE_ERROR,
  SEND_DEVICE_SMS,
  SEND_DEVICE_SMS_SUCCESS,
  SEND_DEVICE_SMS_ERROR,
  DELETE_DEVICE,
  DELETE_DEVICE_SUCCESS,
  DELETE_DEVICE_ERROR,
  UPDATE_DEVICE,
  UPDATE_DEVICE_SUCCESS,
  UPDATE_DEVICE_ERROR,
  SET_DEVICE_PERMISSIONS,
} from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.device;
const device = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullDevice') {
        return {
          ...state,
          current: { ...initialSettings.current },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
          linkSimcard: { ...initialSettings.linkSimcard },
          permissions: [],
        };
      }
      if (action.target === 'currentDevice') {
        return {
          ...state,
          current: { ...initialSettings.current },
          permissions: [],
        };
      }
      switch (action.target) {
        case 'updateDevice':
          key = 'update';
          break;
        case 'deleteDevice':
          key = 'delete';
          break;
        case 'linkDeviceSimcard':
          key = 'linkSimcard';
          break;
        case 'sendSmsDevice':
          key = 'sendSms';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case GET_DEVICES_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_DEVICES_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_DEVICES_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: _map(action.data.data, (d) => ({ id: d.id })),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // GET
    case GET_DEVICE:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          error: null,
        },
      };
    case GET_DEVICE_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_DEVICE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: { id: action.data.data.id },
        },
      };
    case GET_DEVICE_INSTALLATION:
      return {
        ...state,
        current: {
          ...state.current,
          loadingInstallation: true,
        },
      };
    case GET_DEVICE_INSTALLATION_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loadingInstallation: false,
          installation: action.data.data,
        },
      };
    case GET_DEVICE_INSTALLATION_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loadingInstallation: false,
          error: action.error,
        },
      };
    // LINK/UNLINK SIMCARD
    case LINK_DEVICE_SIMCARD:
    case UNLINK_DEVICE_SIMCARD:
      return {
        ...state,
        linkSimcard: {
          ...state.linkSimcard,
          done: false,
          error: null,
        },
      };
    case LINK_DEVICE_SIMCARD_ERROR:
    case UNLINK_DEVICE_SIMCARD_ERROR:
      return {
        ...state,
        linkSimcard: {
          ...state.linkSimcard,
          error: action.error,
        },
      };
    case LINK_DEVICE_SIMCARD_SUCCESS:
    case UNLINK_DEVICE_SIMCARD_SUCCESS:
      return {
        ...state,
        linkSimcard: {
          ...state.linkSimcard,
          done: true,
        },
      };
    // SEND CMD
    case SEND_CMD_DEVICE:
      return {
        ...state,
        sendCmd: {
          ...state.sendCmd,
          error: null,
          done: false,
          idDevice: action.id,
        },
      };
    case SEND_CMD_DEVICE_ERROR:
      return {
        ...state,
        sendCmd: {
          ...state.sendCmd,
          error: action.error,
        },
      };
    case SEND_CMD_DEVICE_SUCCESS:
      return {
        ...state,
        sendCmd: {
          ...state.sendCmd,
          done: true,
          asyncOperation: action.data.data,
        },
      };
    // SEND SMS CMD
    case SEND_DEVICE_SMS:
      return {
        ...state,
        sendSms: {
          ...state.sendSms,
          error: null,
          done: false,
        },
      };
    case SEND_DEVICE_SMS_ERROR:
      return {
        ...state,
        sendSms: {
          ...state.sendSms,
          error: action.error,
        },
      };
    case SEND_DEVICE_SMS_SUCCESS:
      return {
        ...state,
        sendSms: {
          ...state.sendSms,
          done: true,
        },
      };
    // DELETE
    case DELETE_DEVICE:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case DELETE_DEVICE_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_DEVICE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // UPDATE
    case UPDATE_DEVICE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case UPDATE_DEVICE_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_DEVICE_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // SET_DEVICE_PERMISSIONS
    case SET_DEVICE_PERMISSIONS:
      return {
        ...state,
        permissions: action.permissions,
      };
    default:
      return state;
  }
};

export default device;



// WEBPACK FOOTER //
// ./reducers/device/device.js